import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import arkadu from "src/coreConfig";
import axios from "src/utils/axios";

const sections = {
  classroom: {
    title: "Aula Virtual",
    icon: "classroom",
    module_name: "classroom",
    href: `/classroom/`,
    public: true,
  },
  nets_corporate: {
    title: "Trámites",
    icon: "clipboard",
    module_name: "nets_corporate",
    href: `/corporate/`,
    public: true,
  },
  nets_requests: {
    title: "Solicitudes",
    module_name: "nets_requests",
    icon: "requestPage",
    href: `/requests/`,
    public: true,
  },
  nets_taxes: {
    title: "Hacienda",
    module_name: "nets_taxes",
    icon: "briefcaseIcon",
    href: `/taxes/`,
    public: true,
  },
  nets_informal: {
    title: "Economía Popular",
    module: "nets_informal",
    icon: "informalEconomy",
    href: "/infeco/",
    public: true,
  },
  nets_stamp: {
    title: "Timbres fiscales",
    module_name: "nets_stamp",
    icon: "photoSize",
    href: `/stamp/`,
    public: true,
  },
  nets_suppliers: {
    title: "Compras",
    module_name: "nets_suppliers",
    icon: "shoppingCart",
    href: `/suppliers/`,
    public: false,
  },
  nets_eventads: {
    title: "Publicidad y Eventos",
    icon: "ads",
    href: "/eventads/",
    public: true,
  },
  nets_customers: {
    title: "Cuenta Cliente",
    icon: "briefcaseIcon",
    href: "/customer/",
    public: false,
  },
  nets_planning: {
    title: "Planificación",
    icon: "briefcaseIcon",
    href: "/planning/",
    public: false,
  },
  shopping_cart: {
    title: "Pagos",
    module_name: "shopping_cart",
    icon: "shoppingCartIcon",
    href: `/accounts/`,
    public: true,
  },
  nets_translate: {
    title: "Traducciones",
    module_name: "nets_translate",
    icon: "LanguageRounded",
    href: `/accounts/`,
  },
  nets_cadastre: {
    title: "Catastro",
    module_name: "nets_cadastre",
    icon: "map",
    href: `/cadaster/`,
    public: true,
  },
  nets_support: {
    title: "Soporte",
    icon: "support",
    href: `/support/`,
    public: true,
  },
  nets_police: {
    title: "Policia",
    module_name: "nets_police",
    icon: "security",
    href: `/police/`,
    public: true,
  },
  nets_civil: {
    title: "registro civil",
    icon: "civil",
    href: `/civil/`,
    public: true,
  },
  nets_notify: {
    title: "Mensajería",
    icon: "email",
    href: `/notify/`,
    public: false,
  },
  nets_motor: {
    title: "Vehículos",
    icon: "cartIcon",
    href: `/motor/`,
    public: true,
  },
  nets_urbin: {
    title: "Control Urbano",
    icon: "urbin",
    href: `/urbin/`,
    public: true,
  },
  nets_blog: {
    title: "Noticias",
    icon: "rss_feed",
    href: `/cms/`,
    public: true,
  },
  nets_environment: {
    title: "Ambiente",
    icon: "eco",
    href: `/environment/`,
    public: true,
  },
  nets_fire_department: {
    title: "Bomberos",
    module_name: "nets_fire_department",
    icon: "fireDepartment",
    href: `/fire-department/`,
    public: true,
  },
  nets_bank: {
    title: "Banca",
    icon: "bank",
    href: `/bank/`,
    public: true,
  },
  nets_service: {
    title: "Servicios",
    module_name: "nets_service",
    icon: "libraryBooks",
    href: `/service/`,
    public: true,
  },
  nets_global: {
    title: "Global",
    module_name: "nets_global",
    icon: "tuneIcon",
    href: "/global/",
    public: false,
  },
  nets_poll: {
    title: "Encuestas",
    module_name: "nets_poll",
    icon: "pollIcon",
    href: "/poll/",
    public: true,
  },
  nets_dev: {
    title: "Sistema",
    module_name: "nets_dev",
    icon: "developerBoard",
    href: "/system/",
    public: false,
    items: [
      {
        title: "Desarrollo",
        icon: "developerBoard",
        href: `/system/dev/`,
        public: false,
      },
    ],
  },
  nets_erp: {
    title: "ERP",
    module_name: "nets_erp",
    icon: "erp",
    href: "/erp/",
    public: false,
    items: [
      {
        title: "Bienes",
        icon: "archive",
        href: `/erp/inventory/`,
        public: false,
      },
      {
        title: "Contabilidad",
        icon: "menuBook",
        href: `/erp/accounting/`,
        public: false,
      },
      {
        title: "RRHH",
        icon: "groupWork",
        href: `/erp/staff/`,
        public: false,
      },
      {
        title: "Presupuesto",
        icon: "timelineTwoTone",
        href: `/erp/budget/`,
        public: false,
      },
      {
        title: "Proveedores",
        icon: "input",
        href: `/erp/suppliers/`,
        public: false,
      },
      {
        title: "Proyectos",
        icon: "timelapse",
        href: `/erp/project/`,
        public: false,
      },
      {
        title: "Seguridad",
        icon: "security",
        href: `/erp/security/`,
        public: false,
      },
    ],
  },
  nets_socialresp: {
    title: "Responsabilidad Social",
    module_name: "nets_socialresp",
    icon: "socialResp",
    href: "/socialresp/",
    public: true,
  },
  nets_audit: {
    title: "Fiscalización",
    module_name: "nets_audit",
    icon: "audit",
    href: "/audit/",
    public: true,
  },
  nets_dinvoice: {
    title: "Facturación",
    module_name: "nets_dinvoice",
    icon: "invoice",
    href: "/dinvoice/",
    public: false,
  },
  nets_documents: {
    title: "Documentos Oficiales",
    module_name: "nets_documents",
    icon: "documents",
    href: "/documents/",
    public: true,
  },
  nets_signature: {
    title: "Firma Electrónica",
    module_name: "nets_signature",
    icon: "signature",
    href: "/signature/inbox/",
    public: true,
  },
  nets_certificate: {
    title: "Certificados",
    module_name: "nets_certificate",
    icon: "certificate",
    href: "/certificate/",
    public: true,
    items: [
      {
        title: "Emitidos",
        icon: "certificate",
        href: "/certificate/queue/",
        public: true,
      },
      {
        title: "Firmantes",
        icon: "signature",
        href: "/certificate/signers/",
        public: true,
      },
    ],
  },
  nets_approval: {
    title: "DVA",
    module_name: "nets_approval",
    icon: "approval",
    href: "/approval/",
    public: false,
  },
};

const sanitizeModulePath = (value) => {
  if (!value || typeof value !== "string") return "";
  return value.trim().replace(/^\/+|\/+$/g, "");
};

const featureNodeEnabled = (featureNode) => {
  if (typeof featureNode === "boolean") return featureNode;
  if (featureNode && typeof featureNode === "object") {
    if (typeof featureNode.enabled === "boolean") return featureNode.enabled;
    return true;
  }
  return Boolean(featureNode);
};

const getFeatureNode = (features, featurePath) => {
  if (!features || typeof features !== "object") return undefined;
  return featurePath.split(".").reduce((acc, key) => {
    if (acc && typeof acc === "object") return acc[key];
    return undefined;
  }, features);
};

const moduleEnabledByPlan = (customer, moduleName) => {
  const features = customer?.subscription_plan?.features;

  if (!features || typeof features !== "object") {
    return true;
  }

  const moduleFeature = getFeatureNode(features, `${moduleName}.enabled`);
  if (typeof moduleFeature === "undefined") {
    return true;
  }

  return featureNodeEnabled(moduleFeature);
};

const buildCustomerSections = (customer) => {
  const modules = _.orderBy(
    customer?.arkadu_modules || [],
    ["order"],
    ["desc"],
  );

  return modules
    .filter((module) => moduleEnabledByPlan(customer, module.name))
    .map((module) => {
      const sectionConfig = sections[module.name] || {};
      const fallbackPath =
        sanitizeModulePath(module.path) || module.name.replace(/^nets_/, "");
      const resolvedTitle =
        sectionConfig.title || module.verbose_name || module.name;
      const resolvedModuleName = sectionConfig.module_name || module.name;
      const resolvedIcon = sectionConfig.icon || module.icon || "libraryBooks";
      const resolvedHref =
        sectionConfig.href || module.href || `/${fallbackPath}/`;
      const resolvedPublic =
        typeof sectionConfig.public !== "undefined"
          ? sectionConfig.public
          : true;

      return {
        ...module,
        ...sectionConfig,
        title: resolvedTitle,
        module_name: resolvedModuleName,
        icon: resolvedIcon,
        href: resolvedHref,
        public: resolvedPublic,
      };
    });
};

const initialState = {
  customers: [],
  customersList: [],
  countries: [],
  isModalOpen: false,
  selectedCustomerId: null,
  selectedRange: null,
  currentCustomer: null,
  lastAdmin: null,
  customerError: null,
  categories: [],
  customerPermissions: {
    viewCustomer: false,
    changeCustomer: false,
    addMember: false,
    changeMember: false,
    viewMemberLogs: false,
    changeMemberRoles: false,
    addDepartment: false,
    addStaff: false,
    addSchedule: false,
  },
  customerModules: {},
  currentApp: null,
  customerProcedures: [],
  customersLoaded: false,
  customerSections: [],
  currencyCode: "",
  stats: null,
  periods: null,
  periodsStats: null,
  retentionActivities: null,
};

const slice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    getCustomers: (state, action) => {
      const { data } = action.payload;

      state.customers = data;
      var _customerList = [];
      for (var _c in data) {
        for (var _c1 in data[_c].customers) {
          _customerList.push(data[_c].customers[_c1]);
        }
      }
      state.customersList = _customerList;
      // state.countries = data.countries ? data.countries : [];
      state.customersLoaded = true;
    },
    setCustomers: (state, action) => {
      const { data } = action.payload;

      state.customers = data;
      var _customerList = [];
      for (var _c in data) {
        for (var _c1 in data[_c].customers) {
          _customerList.push(data[_c].customers[_c1]);
        }
      }
      state.customersList = _customerList;
      // state.countries = data.countries ? data.countries : [];
      state.customersLoaded = true;
    },
    setCustomerCountries: (state, action) => {
      state.countries = action.payload;
    },
    clearCurrentCustomer: (state, action) => {
      state.currentCustomer = null;
      state.customerError = null;
    },
    setCustomerError: (state, action) => {
      state.customerError = action.payload;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    updateCustomer: (state, action) => {
      const customer = action.payload;
      state.customers = _.map(state.customers, (_c) => {
        if (_c.id === customer.id) {
          return customer;
        }
        return _c;
      });
      state.currentCustomer =
        state.currentCustomer.id === customer.id
          ? customer
          : state.currentCustomer;
      localStorage.setItem("customers", JSON.stringify(state.customers));
    },

    selectCustomer(state, action) {
      const { customerId = null } = action.payload;

      state.isModalOpen = true;
      state.selectedCustomerId = customerId;
    },
    setCustomerPeriods(state, action) {
      state.periods = action.payload;
    },
    setCurrentCustomer(state, action) {
      const { currentCustomer } = action.payload;
      var m = currentCustomer;
      m.arkadu_modules = _.sortBy(m.arkadu_modules, ["order"]).reverse();
      state.currentCustomer = currentCustomer;
      state.customerError = null;

      state.customerSections = buildCustomerSections(currentCustomer);
      // customer Modules is a dict from arkadu_modules using name as key
      state.customerModules = _.reduce(
        currentCustomer.arkadu_modules,
        (acc, module) => {
          acc[module.name] = module;
          return acc;
        },
        {},
      );

      if (currentCustomer && currentCustomer.departments) {
        state.customerProcedures = _.reject(
          currentCustomer.departments,
          (_d) => _d.procedures.length < 1,
        );
      } else {
        state.customerProcedures = [];
      }
      state.customerProcedures = _.map(currentCustomer.departments, (_d) => {
        if (_d.procedures.length > 0) {
          return _d;
        }
      });
    },
    updateCurrentCustomerPeriod: (state, action) => {
      const period = action.payload;
      state.currentCustomer = {
        ...state.currentCustomer,
        periods: _.map(state.currentCustomer.periods, (_p) => {
          if (_p.id === period.id) {
            return period;
          }
          return _p;
        }),
      };
    },
    openModal(state) {
      state.isModalOpen = true;
    },
    closeModal(state) {
      state.isModalOpen = false;
      state.selectedCustomerId = null;
      state.selectedRange = null;
    },
    setStats: (state, action) => {
      const { data, periods } = action.payload;
      state.stats = data;
      state.periods = periods;
    },
    setCurrentApp: (state, action) => {
      state.currentApp = action.payload;
    },
    setCustomerByName: (state, action) => {
      const { shortname } = action.payload;
      var m = _.find(
        state.customers,
        (_customer) =>
          _customer.shortname.toLowerCase() === shortname.toLowerCase(),
      );
      if (!m) {
        return state;
      }
      m.arkadu_modules = _.orderBy(m.arkadu_modules, ["order"], ["desc"]);
      state.customerSections = buildCustomerSections(m);
      state.currentCustomer = m;
      if (m && m.departments) {
        state.customerProcedures = _.reject(
          m.departments,
          (_d) => _d.procedures.length < 1,
        );
      } else {
        state.customerProcedures = [];
      }
    },
    setCustomerItem: (state, action) => {
      const { itemName, data } = action.payload;
      state[itemName] = data;
    },
    setLastAdmin: (state, action) => {
      state.lastAdmin = action.payload;
    },
    setRetentionActivities: (state, action) => {
      state.retentionActivities = action.payload;
    },
    setCustomerById: (state, action) => {
      if (state.customersList) {
        var m = _.find(state.customersList, {
          id: parseInt(action.payload),
        });
        if (m) {
          state.currentCustomer = m;
          var arkaduModules = _.orderBy(
            state.currentCustomer.arkadu_modules,
            ["order"],
            ["desc"],
          );
          state.customerSections = buildCustomerSections({
            ...state.currentCustomer,
            arkadu_modules: arkaduModules,
          });
        }
      }
    },
  },
});

export const reducer = slice.reducer;

export const loadCustomers = () => async (dispatch) => {
  var localCustomer = localStorage.getItem("customers");

  if (localCustomer) {
    dispatch(slice.actions.setCustomers({ data: JSON.parse(localCustomer) }));
  }
};

export const setCustomers = (data) => async (dispatch) => {
  dispatch(slice.actions.setCustomers(data));
};
// Several effects call getCustomers when the list is empty; on backend errors the
// empty list re-triggered them in a tight loop that amplified server outages.
// Requests are de-duplicated and failures are retried with exponential backoff.
const CUSTOMERS_RETRY_BASE_MS = 2000;
const CUSTOMERS_RETRY_MAX_MS = 60000;
let customersRequest = null;
let customersRetryTimer = null;
let customersFailures = 0;

export const getCustomers = () => async (dispatch) => {
  if (customersRequest) {
    return customersRequest;
  }
  if (customersRetryTimer) {
    return undefined;
  }
  customersRequest = fetchCustomersList(dispatch).finally(() => {
    customersRequest = null;
  });
  return customersRequest;
};

const scheduleCustomersRetry = (dispatch) => {
  customersFailures += 1;
  const backoff = Math.min(
    CUSTOMERS_RETRY_MAX_MS,
    CUSTOMERS_RETRY_BASE_MS * 2 ** (customersFailures - 1),
  );
  const delay = backoff * (0.75 + Math.random() * 0.5);
  customersRetryTimer = setTimeout(() => {
    customersRetryTimer = null;
    dispatch(getCustomers());
  }, delay);
};

const fetchCustomersList = async (dispatch) => {
  try {
    const response = await axios.get(arkadu.urls.v2.customer.list);
    const payload = response?.data;
    const data = payload?.data || [];

    customersFailures = 0;
    dispatch(slice.actions.getCustomers({ data }));
    localStorage.setItem("customers", JSON.stringify(data));
  } catch (err) {
    console.error("getCustomers failed", err);
    scheduleCustomersRetry(dispatch);
    dispatch(slice.actions.setCustomers({ data: [] }));
    dispatch(
      slice.actions.setCustomerError(
        err?.response?.data?.message ||
          err?.data?.message ||
          "No se pudo cargar el catálogo de clientes",
      ),
    );
  }
};

export const fetchCustomerFromServer = (data) => async (dispatch) => {
  try {
    var c = await axios.post(arkadu.urls.v2.customer.detail, data);
    var lastRequest = new Date();
    var cus = c.data.data;
    if (cus) {
      cus["lastRequest"] = `${lastRequest}`;
      localStorage.setItem(data.shortname, JSON.stringify(cus));
      dispatch(slice.actions.setCurrentCustomer({ currentCustomer: cus }));
    }
  } catch (err) {
    console.log(err);
    if (err.data) {
      dispatch(slice.actions.setCustomerError(err.data.message));
    }
  }
};

export const fetchCustomerJson = (data) => async (dispatch) => {
  // Customer detail is now the canonical source; taxes classifier is loaded in taxes hooks.
  await dispatch(fetchCustomerFromServer(data));
};

export const getCustomerStats = (data) => async (dispatch) => {
  var c = await axios.post(arkadu.urls.v2.customer.stats, data);
};
export const getCategories = (data) => async (dispatch) => {
  var response = await axios.get(arkadu.urls.v2.customer.categories);
  if (response.data.res === 1) {
    dispatch(slice.actions.setCategories(response.data.data));
  }
};
export const getCustomerCountries = (data) => async (dispatch) => {
  var url = arkadu.urls.site.geo_data;
  const response = await axios.get(url);
  dispatch(slice.actions.setCustomerCountries(response.data.data));
};

export const setCurrentCustomer = (data) => async (dispatch) => {
  dispatch(fetchCustomerJson(data));

  dispatch(slice.actions.setCurrentCustomer({ currentCustomer: data }));
};
export const setCustomerById = (id) => async (dispatch) => {
  dispatch(slice.actions.setCustomerById(id));
};

// export const createCustomer = (data) => async (dispatch) => {
//   const response = await axios.post('/api/calendar/customers/new', data);

//   dispatch(slice.actions.createCustomer(response.data));
// };

export const updateCustomer = (data) => async (dispatch) => {
  dispatch(slice.actions.updateCustomer(data));
};
export const selectCustomer = (customerId) => async (dispatch) => {
  dispatch(slice.actions.selectCustomer({ customerId }));
};

export const updateCurrentCustomerPeriod = (data) => async (dispatch) => {
  dispatch(slice.actions.updateCurrentCustomerPeriod(data));
};

export const getStats = (data) => async (dispatch) => {
  var response = await axios.post(arkadu.urls.v2.customer.stats, data);

  dispatch(slice.actions.setStats(response.data));
};

export const setCustomerItem = (data) => async (dispatch) => {
  dispatch(slice.actions.setCustomerItem(data));
};

export const setCustomerByName = (data) => async (dispatch, getState) => {
  const shortname = String(data?.shortname || "").toLowerCase();
  if (!shortname) {
    return;
  }

  let customer = null;
  const stateCustomers = getState()?.customers;
  const customersList = stateCustomers?.customersList || [];
  let hadLocalCatalog = false;

  if (customersList.length > 0) {
    customer = customersList.find(
      (c) => c?.shortname?.toLowerCase() === shortname,
    );
  }

  if (!customer) {
    const s = localStorage.getItem("customers");
    if (s) {
      try {
        const customers = JSON.parse(s);
        hadLocalCatalog = Array.isArray(customers) && customers.length > 0;
        customers.forEach((group) => {
          if (customer || !group?.customers) {
            return;
          }
          const match = group.customers.find(
            (c) => c?.shortname?.toLowerCase() === shortname,
          );
          if (match) {
            customer = match;
          }
        });
      } catch (e) {
        console.error("error parsing customers storage", e);
      }
    }
  }

  if (customer) {
    dispatch(
      slice.actions.setCurrentCustomer({ currentCustomer: { ...customer } }),
    );
    return;
  }

  // Fallback: resolver cliente directamente en backend para evitar falsos
  // negativos cuando el catálogo local aún no se ha hidratado.
  try {
    const response = await axios.post(arkadu.urls.v2.customer.detail, {
      shortname,
    });
    const resolvedCustomer = response?.data?.data;
    if (resolvedCustomer) {
      dispatch(
        slice.actions.setCurrentCustomer({
          currentCustomer: { ...resolvedCustomer },
        }),
      );
      return;
    }
  } catch (_error) {
    // Ignorado: abajo se reporta error de cliente no encontrado solo cuando
    // realmente no se pudo resolver por ninguna fuente.
  }

  // Si no hay catálogo local todavía, evitamos marcar not-found prematuro.
  if (customersList.length === 0 && !hadLocalCatalog) {
    return;
  }

  dispatch(slice.actions.clearCurrentCustomer());
  dispatch(
    slice.actions.setCustomerError(
      `No se encontró el cliente solicitado en la URL: ${data?.shortname}`,
    ),
  );
  console.error("customer not found", data?.shortname);
};
export const openModal = () => async (dispatch) => {
  dispatch(slice.actions.openModal());
};
export const clearCurrentCustomer = () => async (dispatch) => {
  dispatch(slice.actions.clearCurrentCustomer());
};

export const setCurrentApp = (data) => async (dispatch) => {
  dispatch(slice.actions.setCurrentApp(data));
};

export const closeModal = () => async (dispatch) => {
  dispatch(slice.actions.closeModal());
};

export const setLastAdmin = (data) => async (dispatch) => {
  dispatch(slice.actions.setLastAdmin(data));
};

export const setRetentionActivities = (data) => async (dispatch) => {
  dispatch(slice.actions.setRetentionActivities(data));
};
export const setCustomerPeriods = (data) => async (dispatch) => {
  dispatch(slice.actions.setCustomerPeriods(data));
};
export default slice;
